var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("div", { staticClass: "filter" }),
          _vm._v(" "),
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading.general,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          _c("table", { staticClass: "table mt-0 table-sm table-hover" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.records, function (r, i) {
                return _c(
                  "tr",
                  {
                    class: {
                      bg_danger: _vm.hasOverDueDate(
                        _vm.details[r.id]?.date_value
                      ),
                    },
                  },
                  [
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          i +
                            1 +
                            (_vm.paginator.current_page - 1) *
                              _vm.paginator.per_page
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(r.title) + " (" + _vm._s(r.id) + ")"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c("DrugCommentsBlock", {
                          ref: "drugsManagersComments",
                          refInFor: true,
                          attrs: {
                            allowToSave: true,
                            disableStartNewRecord: true,
                            detail: _vm.details[r.id],
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.paginator
                ? _c("paginate", {
                    ref: "Pagination",
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 11,
                      "margin-pages": 2,
                      "click-handler": _vm.getRecords,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.paginator.current_page,
                      callback: function ($$v) {
                        _vm.$set(_vm.paginator, "current_page", $$v)
                      },
                      expression: "paginator.current_page",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Комментарии к препаратам")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", { attrs: { width: "20%" } }, [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Комментарий")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }